import axios from "axios";
import { buildHeaders } from "../_headers.util";
import { resolveApiBaseUrl } from "@/utils/hostname";

const API_URL = resolveApiBaseUrl();

export default {
  listDomains(params = {}) {
    return axios.get(`${API_URL}domains`, {
      params,
      headers: buildHeaders(),
    });
  },
  listTenants(params = {}) {
    return axios.get(`${API_URL}tenants`, {
      params,
      headers: buildHeaders(),
    });
  },
  getCompanyWorkspace(companyId) {
    return axios.get(`${API_URL}companies/${companyId}/workspace`, {
      headers: buildHeaders(),
    });
  },
  checkSlug(slug, companyId = null) {
    return axios.get(`${API_URL}workspace/slug-check`, {
      params: { slug, company_id: companyId || undefined },
      headers: buildHeaders(),
    });
  },
  migrateCompanyToTenant(companyId, payload = {}) {
    return axios.post(`${API_URL}companies/${companyId}/migrate-to-tenant`, payload, {
      headers: buildHeaders(),
    });
  },
  suspendTenant(tenantId) {
    return axios.post(`${API_URL}tenants/${tenantId}/suspend`, null, {
      headers: buildHeaders(),
    });
  },
  activateTenant(tenantId) {
    return axios.post(`${API_URL}tenants/${tenantId}/activate`, null, {
      headers: buildHeaders(),
    });
  },
  runTenantMigrations(tenantId) {
    return axios.post(`${API_URL}tenants/${tenantId}/migrate`, null, {
      headers: buildHeaders(),
    });
  },
};
